<template>
    <div class="myaddress">
        <div class="ipoint-payment-group">
            <label class="profile-radio" @click="checkRadio(0,$event)">
                <span class="pro-radio" v-bind:class="{'pro-radio-checked':tag == flag}">
                    <span class="pro-radio-inner"></span>
                    <input type="radio" class="pro-radio-input">
                </span>
                <div class="payment-group payment-group-paypal">
                    <div class="payment-desc">
                        <p class="pay-title" style="margin-top: -10px;">{{$t('delivery_address')}}</p>
                        <div class="address_box">
                            <ul class="address_now">
                                <li v-for="(tab,index) in addressGroup"
                                    :key="index"
                                    @click="checkaddress(tab.address_id,$event)"
                                    v-bind:class="{active:tab.is_default===1}">
                                    {{tab.name}}
                                    <p>{{tab.mobile}}</p>
                                    <p>{{tab.all_address}}</p>
                                    <a href="javascript:;" @click="editAddress(index)">{{$t('user_center_btn_modify')}}</a>
                                </li>
                            </ul>
                        </div>
                        <button class="btn-primary btn-hollow" @click.stop="ShowAddress">
                            {{$t('user_center_add_address')}}
                        </button>
                    </div>
                </div>
            </label>

            <label class="profile-radio" @click="checkRadio(1,$event)" style="padding:35px 0 35px 0">
                <span class="pro-radio" v-bind:class="{'pro-radio-checked':tag == !flag}">
                    <span class="pro-radio-inner"></span>
                    <input type="radio" class="pro-radio-input">
                </span>
                <div class="payment-group payment-group-paypal">
                    <div class="payment-desc">
                        <p class="pay-title" style="margin-top: -10px;">{{$t('user_order_pick_up')}}</p>
                        <p class="address_offline">{{$t('user_order_pick_up_offline_store')}}</p>
                        <ul class="choose_store" v-if="iSstore">
                            <li v-for="(item,index) in storeList" :key="index"  @click="checkstore(item.id,index,$event)" :class="{active:index == num}">
                                    <p class="choose_store_title">{{item.name}}</p>
                                    <div class="storeList_content" v-if="isShowcontent == index">
                                        <p class="choose_store_content">{{item.address}}</p>
                                        <p class="choose_store_content">{{item.phone}}</p>
                                    </div>
                                    <p class="choose_detail" @click="Showcontent(index,$event)">{{$t('store_mainpage_details')}} ></p>
                            </li>
                        </ul>
                    </div>
                </div>
            </label>
        </div>
        <!--添加地址窗口-->
        <modal class="add_Address" v-model="addAddress" :title="$t('user_center_add_address_tittle')">
            <input type="hidden" v-if="addAddressGroup.address_id !== null" v-model="addAddressGroup.address_id">
            <div class="addr_modal">
                <p class="addr_modal_tips">{{$t('user_center_Coupons_Use_tips')}}: <span>*</span>{{$t('add_address_must_item')}}</p>
                <div class="addr_group">
                    <div class="addr_laber">
                        {{$t('add_address_area')}}<span>*</span>
                    </div>
                    <div class="addr_item1">
                        <select name="addAddressGroup_country" v-model="addAddressGroup.country">
                            <option :value="item.id" v-for="(item,index) in countrys"
                                    :key="index">{{item.country_name}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="addr_group">
                    <div class="addr_laber">
                        {{$t('add_address_address')}}<span>*</span>
                    </div>
                    <div class="addr_item2">
                        <textarea cols="30" rows="6" :placeholder="$t('add_address_address_full')" v-validate="'required'" name="addAddressGroup_address"
                                  :class="{'is-error': errors.has('addAddressGroup_address')}"
                                  v-model="addAddressGroup.address"></textarea>
                    </div>
                </div>
                <div class="addr_group">
                    <div class="addr_laber">
                        {{$t('add_address_zip_code')}}
                    </div>
                    <div class="addr_item1">
                        <input type="text" v-validate="'required|numeric'" name="addAddressGroup_zipcode" :placeholder="$t('add_address_zip_code_full')"
                               :class="{'is-error': errors.has('addAddressGroup_zipcode')}"
                               v-model="addAddressGroup.zipcode">
                    </div>
                </div>
                <div class="addr_group">
                    <div class="addr_laber">
                        {{$t('about_ifree_join_sub_name')}}<span>*</span>
                    </div>
                    <div class="addr_item1">
                        <input type="text" v-validate="'required|min:1'" :placeholder="$t('add_address_first_name_full')" name="addAddressGroup_last_name"
                               :class="{'is-error': errors.has('addAddressGroup_last_name')}"
                               v-model="addAddressGroup.name"
                        >
                    </div>
                </div>
                <div class="addr_group">
                    <div class="addr_laber">
                        {{$t('about_ifree_join_sub_number')}}<span>*</span>
                    </div>
                    <div class="addr_item1">
                        <select v-model="addAddressGroup.area_code" style="margin-bottom: 10px;">
                            <option v-for="(item,index) in cityiso" :value="item.area_code" :key="index">
                                {{item.area_code}} {{item.name}}
                            </option>
                        </select>
                        <input v-validate="'required|min:11'" name="bind_phone" v-model="addAddressGroup.mobile"
                               :class="{'is-error': errors.has('bind_phone')}" type="text" class="form-input"
                               :placeholder="this.$t('add_number_number')">
                    </div>
                </div>
                <div class="addr_group">
                    <div class="addr_laber"></div>
                    <div class="addr_item1">
                        <Checkbox style="font-size: 14px;color: #5E6D82;" @on-change="check_default" class="checkALL" v-model="default_single">
                            {{$t('add_address_defult_address')}}
                        </Checkbox>
                    </div>
                </div>
                <div class="addr_group">
                    <div class="addr_laber"></div>
                    <div class="addr_item1">
                        <button class="btn-pt btn-blue" @click="saveAddress">
                            {{$t('determine_btn')}}
                        </button>
                    </div>
                </div>
            </div>

            <div slot="footer"></div>
        </modal>
    </div>
</template>
<script>
    import modal from '../../Common/Modal.vue'
    import Signature from '../../../lib/Signature'

    export default {
        name: 'MyAddress',
        data () {
            return {
                addAddress: false,
                storeId:'',
                add_mobile:'',
                iSstore: false,
                default_single:false,
                num: 0,
                bind_iso: '86',
                isShowcontent:0,
                cityiso:[],
                tag: this.flag,
                addressGroup: [],
                storeList: [],
                addAddressGroup: {
                    address_id: null,
                    first_name: '',
                    last_name: '',
                    email: '',
                    country: '35',
                    city: '',
                    address: '',
                    zipcode: '',
                    mobile: ''
                },
                countrys:'',
            }
        },
        props: {
            flag: {
                type: Number,
                default: 0
            }
        },
        components: {
            modal
        },
        created () {
            this.getAddressGroup()
            let module = 'index.php/index/user/getcountry'
            let data = {}
            data.sub_time = Signature.timestamp()
            data.lang = this.$i18n.locale
            data.sign = Signature.create(module, data.sub_time)
            data.user_id = this.Local.getUserId()
            data.token = this.Local.getUserToken()
            this.$http.get(process.env.BASEURL + module, {params: data})
                .then(function (response) {
                    if (parseInt(response.data.code) === 2000) {
                        this.countrys =response.data.data.country_list
                    }
            }.bind(this))

            this.store_list()

            // 获取国家iso
            this.iso()

        },
        methods: {
            ShowAddress(){
                this.addAddress = true
            },
            check_default (){
                if(this.default_single == true){
                    this.default = 1
                }
            },
            editAddress (index) {
                this.addAddress = true
                this.addAddressGroup = this.addressGroup[index]
            },
            getAddressGroup () {
                let module = 'index.php/index/user/addressinfo'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.lang = this.$i18n.locale
                data.sign = Signature.create(module, data.sub_time)
                data.user_id = this.Local.getUserId()
                data.token = this.Local.getUserToken()
                this.$http.get(process.env.BASEURL + module, {params: data})
                .then(function (response) {
                    if (parseInt(response.data.code) === 2000) {
                        this.addressGroup = response.data.data.address_info
                    }
                }.bind(this))
            },
            cancelAddress () {
                this.addAddress = false
            },
            saveAddress () {
                let module = 'index.php/address'
                let data = {}
                for (let item in this.addAddressGroup) {
                    data[item] = this.addAddressGroup[item]
                }
                data.sub_time = Signature.timestamp()
                data.lang = this.$i18n.locale
                data.sign = Signature.create(module, data.sub_time)
                data.user_id = this.Local.getUserId()
                this.$http.post(process.env.BASEURL + module, data).then(function (resp) {
                    if (parseInt(resp.data.code) === 2000) {
                        this.$Message.success(resp.data.msg)
                        this.getAddressGroup()
                        this.addAddress = false
                    }
                    if (parseInt(resp.data.code) === 2001) {
                        this.$Message.error(resp.data.msg)
                    }
                }.bind(this))
            },
            checkRadio (index, e) {
                this.tag = index
                if (e.target.nodeName === 'INPUT') {
                    this.tag = index
                    if (index === 1) {
                        for (let tag of this.addressGroup) {
                            tag.is_default = 0
                        }
                        this.iSstore = true
                    }else{
                        this.iSstore = false
                    }
                    this.$emit('on-checked', index)
                }
            },
            selectNumber (index) {
                this.total = index
            },
            checkaddress (id, e) {
                for (let tag of this.addressGroup) {
                    if (tag.address_id === id) {
                        tag.is_default = 1
                    } else {
                        tag.is_default = 0
                    }
                }
                this.$emit('on-address', id)
            },
            checkstore(id,index,e){
                this.num = index
                this.storeId = id
                this.$emit('on-checkstore', this.storeId)
                this.isShowcontent = index
            },
            handleSubmit (name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.$Message.success(this.$t('user_message_submit_success'))
                    } else {
                        this.$Message.error(this.$t('user_message_verify_fail'))
                    }
                })
            },
            handleReset (name) {
                this.$refs[name].resetFields()
            },
            store_list () {
                let module = 'index.php/offline_store'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.lang = this.$i18n.locale
                data.sign = Signature.create(module, data.sub_time)
                this.$http.get(process.env.BASEURL + module, {params: data})
                    .then(function (response) {
                        if (parseInt(response.data.code) === 2000) {
                            this.storeList =response.data.data
                        }
                }.bind(this))
            },
            Showcontent (index) {
                let routeData = this.$router.resolve({
                    name:'Shop',
                    query:{
                        id : index+1
                    }
                });
                window.open(routeData.href, '_blank');
            },
            //获取国家iso
            iso(){
                let data = {}
                let module = 'index.php/index/other/isocountry'
                data.sub_time = Signature.timestamp()
                data.lang = this.$i18n.locale
                data.sign = Signature.create(module, data.sub_time)
                this.$http.post(process.env.BASEURL + module, data)
                    .then(function (resp) {
                        if (parseInt(resp.data.code) === 2000) {
                            this.cityiso = resp.data.data.country_list
                        }
                    }.bind(this))
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "../../../scss/common";

    .myaddress {
        margin: 0 auto;
    }


    .ipoint-topup {
        padding: 20px 0;
        &:last-child {
            border-bottom: none;
        }
        &.ipoint-payment .ipoint-payment-group {
            text-align: left;
            margin: 0 auto;
            .profile-radio {
                align-items: baseline;
            }
        }
        .ipoint-payment-group {
            & > label {
                margin-bottom: 20px;
            }
            .payment-group {
                margin-left: 20px;
            }
            .pay-title {
                font-size: 24px;
                margin-bottom: 10px;
            }
            .payment-input {
                border: 1px solid #99A9BF;
                border-radius: 5px;
                padding: 5px;
                line-height: 2;
                width: 100%;
                font-size: 16px;
                &::-webkit-input-placeholder, &::-moz-placeholder {
                    color: #99A9BF;
                }
            }
            .payment-group-paypal {
                display: flex;
                align-items: center;
            }
            .payment-icon {
                border: 1px solid #D3DCE6;
                background: transparent;
                padding: 5px;
                border-radius: 5px;
                img {
                    display: inherit;
                }
            }
        }
        .pay-tips {
            font-size: 16px;
            color: rgba(94, 109, 130, 0.87);
            letter-spacing: 0;
            line-height: 20px;
        }
        .pay-subtotal {
            font-size: 16px;
            margin-top: 40px;
            text-align: right;
            .pay-tips {
                margin: 10px 0;
            }
            .sub-total > span {
                font-size: 24px;
                vertical-align: middle;
                margin-right: 10px;
            }
            span {
                font-size: 18px;
            }
        }

    }

    .myaddress {
    /*//添加地址*/
      .add_Address{
    .modal-wrap{
        width: 95% !important;
        max-width: 635px;
        .modal-content{
            .modal-body {
                padding:20px;
                .add-address-title {
                    p {
                        font-size: 24px;
                        color: #1F2D3D;
                        margin-top: -23px;
                    }
                }
                .addr_modal{
                    .addr_modal_tips{
                        font-size: 14px;
                        color: #5E6D82;
                        padding: 15px 0;
                    }
                    span{
                        color: #0084ff;
                    }
                    .addr_group{
                        padding: 5px 0;
                        display: flex;
                        button{
                            color: white;
                            background: #0084FF;
                            border: none;
                            padding: 5px 0;
                            width: 100px;
                            border-radius: 5px;
                        }
                        .addr_laber{
                            width: 25%;
                            line-height: 32px;
                            text-align: center;
                            padding-right: 10px;
                            min-width: 90px;
                            font-size: 13px;
                        }
                        .addr_item1{
                            width: 75%;
                            select,input{
                                background: #FFFFFF;
                                border: 1px solid #C0CCDA;
                                border-radius: 4px;
                                width: 40%;
                                padding:5px 0 5px 3px;
                                min-width: 170px;
                            }
                        }
                        .addr_item2{
                            width: 85%;
                            textarea{
                                padding-left: 3px;
                                background: #FFFFFF;
                                border: 1px solid #C0CCDA;
                                border-radius: 4px;
                                width: 90%;
                                margin: 5px 10px;
                            }
                        }
                    }
            }
            }
        }
    }
    }
        .ipoint-payment-group {
        }
        .address_box {
            display: flex;
            flex: 1;
        }
        .choose_store{
            font-size: 14px;
            li{
                width: 300px;
                display: inline-block;
                background: #FFFFFF;
                border: 1px solid #99A9BF;
                text-align: center;
                border-radius: 3px;
                margin-top: 15px;
                padding: 10px;
                max-width: 300px;
                margin-right: 10px;
                .choose_store_title{
                    font-size: 18px;
                    font-weight: 300;
                }
                .choose_store_content{
                    /*display: none;*/
                    text-align: left;
                    font-size: 16px;
                }
                .choose_detail{
                    font-size: 16px;
                    text-align: right;
                    color: #0084FF;
                }
                &.active {
                     border: 1px solid #0084FF;
                     box-shadow: 0 3px 10px 0 rgba(94, 109, 130, 0.50);
                 }
                &:hover {
                     border: 1px solid #0084FF;
                 }
            }
        }
        .address_now {
            display: flex;
            font-size: 14px;
            li {
                display: inline-block;
                background: #FFFFFF;
                border: 1px solid #99A9BF;
                border-radius: 3px;
                padding: 10px 40px;
                max-width: 300px;
                margin-right: 10px;
                flex: 1;
                &.active {
                    border: 1px solid #0084FF;
                    box-shadow: 0 3px 10px 0 rgba(94, 109, 130, 0.50);
                }
                &:hover {
                    border: 1px solid #0084FF;
                }
            }
        }
        .btn-hollow{
            margin-top: 10px;
            background: transparent;
            border: 1px solid #0084FF;
            border-radius:5px;
            width: 100px;
            height: 30px;
            color: #0084FF;
        }
        .btn-hollow:hover{
            color: white;
            background: #0084FF;
        }
        .add_address_btn{
           text-align: center;
            margin-top:10px;
            div{
                display: inline-block;
                button{
                    width: 100px;
                    height: 35px;
                    outline: none;
                    border: none;
                    border-radius: 5px;
                }
                .add_btn{
                    color:#ffffff;
                    background: #0084FF;
                }
            }
        }
        .address_offline {
            /*font-family: Roboto-Light;*/
            font-size: 16px;
            color: #5E6D82;
            letter-spacing: 0;
            line-height: 20px;
        }

        .address_btn {
            border: 1px solid #0084FF;
            background: white;
            border-radius: 3px;
            font-size: 16px;
            padding: 4px 30px;
            color: #0084ff;
            &:hover {
                background: #0084ff;
                color: #fff;
            }
        }
        .alert_text {
            /*font-family: Roboto-Light;*/
            font-size: 14px;
            color: #5E6D82;
            letter-spacing: 0;
            line-height: 20px;
        }
        .ivu-modal {
            width: 800px !important;
        }
        .ivu-select-selection {
            width: 100% !important;
        }
        .modal-content {
            background: #F9FCFF;
            border: 1px solid #5E6D82;
            border-radius: 5px;
        }
        .tip-alert {
            padding: 0 4%;
            .tip-title {
                /*font-family: PingFangSC-Semibold;*/
                font-size: 22px;
                color: #1F2D3D;
                letter-spacing: 0;
                line-height: 40px;
            }
            .tip-body {
                /*font-family: PingFangSC-Regular;*/
                font-size: 16px;
                color: #5E6D82;
                letter-spacing: 0;
                line-height: 24px;
            }
            .tip-button {
                margin-top: 20px;
            }
            .tip-cancel {
                border: 1px solid #5E6D82;
                border-radius: 5px;
                /*font-family: PingFangSC-Regular;*/
                font-size: 16px;
                color: #5E6D82;
                line-height: 24px;
                padding: 6px 30px;
                margin: 0 10px;
            }
            .tip-download {
                background: #0084FF;
                border-radius: 5px;
                /*font-family: PingFangSC-Semibold;*/
                font-size: 16px;
                color: #FFFFFF;
                line-height: 24px;
                margin: 0 10px;
            }
            .countries-btn {
                /*font-family: Roboto-Regular;*/
                font-size: 16px;
                color: #5E6D82;
                letter-spacing: 0;
                line-height: 14px;
                background: #FFFFFF;
                border: 1px solid #C0CCDA;
                border-radius: 4px;
                padding: 8px;
            }
            .ivu-form-item-label {
                /*font-family: Roboto-Regular;*/
                font-size: 16px;
                color: #5E6D82;
                letter-spacing: 0;
                padding: 0;
                text-align: left;
            }
            .ivu-form-item {
                margin-bottom: 10px;
            }
            .ivu-select-placeholder, .ivu-select-selected-value {
                height: 100%;
                background: #FFFFFF;
                border: 1px solid #C0CCDA;
                border-radius: 4px;
                /*font-family: Roboto-Regular;*/
                font-size: 16px;
                color: #5E6D82;
                letter-spacing: 0;
                text-align: left;
            }
            .ivu-input {
                /*font-family: Roboto-Regular;*/
                font-size: 16px;
                color: #5E6D82;
                letter-spacing: 0;
                line-height: 14px;
            }
            .ivu-checkbox-inner {
                border: 1px solid #5E6D82;
                border-radius: 5px;
            }
        }
    }

    @media screen and (max-width: 500px) {
        .myaddress {
            .address_btn {
                width: 100%;
                font-size: 14px;
                padding: 2px;
            }
        }
    }

    @media screen and (max-width: 768px) {

        .myaddress {
            .address_box {
                display: block;
                width: 100%;
            }
            .address_now, .address_now li {
                display: block;
                width: 100%;
            }
            .address_now li {
                margin-bottom: 10px;
                width: 100%;
                max-width: 100%;
            }
            .btn-hollow{
                margin-top: 20px;
            }
        }

    }

    @media screen and (max-device-height: 777px){
        .modal{
            .modal-wrap{
                top:5% !important;
            }
        }
    }

    @media screen and (max-device-height:670px){
    .modal{
            .modal-wrap{
                top:5% !important;
            }
            .modal_page_main{
                max-height: 350px;
                overflow-y: scroll;
            }
        }

    }



    @import "../../../scss/components/form";
</style>



// WEBPACK FOOTER //
// Myaddress.vue?fd36c55e